import { useMemo } from "react";
import { sideBarColumnsFilters } from "../../../../utils/agGrid/sideBar/sideBarColumnsFilters";

export const useSidebar = (groupByCategory, editing) => {
  return useMemo(() => sideBarColumnsFilters(), []);
};

/**
    const sideBar = useSidebar();
*/
